import React, { useState, useEffect } from "react";
import "./CourseSyllabus.css";
import Popupboxx from "../Popupbox/Popupbox";
import AOS from "aos";
import "aos/dist/aos.css";
const modules = [
  {
    title: "Introduction to Cloud Computing & AWS",
    points: [
      "What is Cloud Computing and its benefits",
      "Overview of AWS cloud platform",
      "Cloud deployment models: Public, Private, Hybrid",
      "Global AWS infrastructure (Regions and Availability Zones)",
    ],
  },
  {
    title: "AWS Core Services",
    points: [
      "Introduction to EC2 (Virtual Servers)",
      "S3 (Simple Storage Service) fundamentals",
      "IAM (Identity and Access Management)",
      "Understanding AWS billing and pricing basics",
    ],
  },
  {
    title: "Networking in AWS",
    points: [
      "Introduction to VPC (Virtual Private Cloud)",
      "Subnets, Route Tables, and Internet Gateway",
      "Security Groups and Network ACLs",
      "Elastic IP and NAT Gateway concepts",
    ],
  },
  {
    title: "AWS Storage & Databases",
    points: [
      "S3 storage classes and lifecycle policies",
      "EBS vs EFS comparison",
      "Introduction to RDS (Relational Database Service)",
      "Overview of DynamoDB (NoSQL database)",
    ],
  },
  {
    title: "AWS Compute & Serverless",
    points: [
      "Working with EC2 instances",
      "Introduction to Lambda (Serverless computing)",
      "Elastic Beanstalk for application deployment",
      "Auto Scaling and Load Balancers",
    ],
  },
  {
    title: "Security & Identity Management",
    points: [
      "IAM users, groups, and roles",
      "MFA (Multi-Factor Authentication) setup",
      "AWS security best practices",
      "Key Management Service (KMS) basics",
    ],
  },
  {
    title: "Monitoring & Management",
    points: [
      "CloudWatch for monitoring AWS resources",
      "CloudTrail for logging and auditing",
      "AWS Config for resource tracking",
      "Setting alarms and notifications",
    ],
  },
  {
    title: "DevOps on AWS",
    points: [
      "CI/CD pipeline basics on AWS",
      "Introduction to CodePipeline, CodeBuild, CodeDeploy",
      "Using GitHub with AWS deployment",
      "Infrastructure as Code with CloudFormation",
    ],
  },
  {
    title: "Real-Time Projects & Deployment",
    points: [
      "Hosting static websites on S3",
      "Deploying web applications on EC2",
      "Serverless application deployment using Lambda",
      "End-to-end AWS project implementation",
    ],
  },
];

function CourseSyllabus() {
  const [activeModule, setActiveModule] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  // Detect screen size
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize(); // check on load
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

   useEffect(() => {
      AOS.init({ duration: 800, once: true });
    }, []);

  return (
    <>
    <section className="syllabus-section">
      <div className="container">
        <div className="headlines-for-all">
          <h4   data-aos="fade-up">
            <span>Course </span> Syllabus
          </h4>
          <p  data-aos="fade-up">
            Explore our comprehensive AWS syllabus — built for
            real-world projects, hands-on learning, and 100% job readiness.
          </p>
        </div>


        {/* ---------- Desktop Tabs ---------- */}
        {!isMobile && (
          <>
            <div className="custom-btn-group "   data-aos="fade-up">
              {modules.map((m, index) => (
                <button
                  key={index}
                  className={`custom-btn ${activeModule === index ? "active" : ""
                    }`}
                  onClick={() => setActiveModule(index)}
                >
                  Module {index + 1}
                </button>
              ))}
            </div>

            <div className="custom-module-container"   data-aos="fade-up">
              <div className="custom-module-box active">
                <h4>{modules[activeModule].title}</h4>
                <ul className="ul-list-module">
                  {modules[activeModule].points.map((p, i) => (
                    <li key={i}>{p}</li>
                  ))}
                </ul>
              </div>
            </div>
          </>
        )}

        {/* ---------- Mobile Accordion (FAQ Style) ---------- */}
        {isMobile && (
          <div className="faq-container-course"   data-aos="fade-up">
            {modules.map((m, index) => (
              <div
                key={index}
                className={`faq-item-course ${activeModule === index ? "open" : ""
                  }`}
              >
                <button
                  className="faq-question-course"
                  onClick={() =>
                    setActiveModule(activeModule === index ? null : index)
                  }
                >
                  {m.title}
                  <span className="faq-icon-course">
                    {activeModule === index ? "−" : "+"}
                  </span>
                </button>

                <div
                  className="faq-answer-course"
                  style={{
                    maxHeight: activeModule === index ? "400px" : "0px",
                  }}
                >
                  <ul>
                    {m.points.map((p, i) => (
                      <li key={i}>{p}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="btn-center"   data-aos="fade-up">
          <button className="download-btn" onClick={() => setIsPopupOpen(true)}>Download Syllabus</button>
        </div>
      </div>
    </section>

  
       <Popupboxx
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
      />
      </>
  );
}

export default CourseSyllabus;
